<template>
  <div :class="['mainBackground testBackground-' + (orderQuestion + 1)]">
    <audio ref="bgSound" loop autoplay>
      <source :src="baseUrl + '/cpr/Sound/E2bg.mp3'" type="audio/mpeg" />
    </audio>
    <button
      class="btn-control btn-close"
      v-c-tooltip="{
        content: 'CLOSE',
        placement: 'bottom',
      }"
      @click="onClose()"
    >
      <i class="fa fa-times close-tip"></i>
    </button>
    <div :class="['big-circle big-circle-' + animationStyle]">
      <div class="backgroundCircle4"></div>
      <div class="backgroundCircle3"></div>
      <div class="backgroundCircle2"></div>
      <div class="backgroundCircle1"></div>
    </div>

    <div class="min-vh-100 d-flex flex-column">
      <div style="flex: auto">
        <CRow
          :key="index"
          class="text-right flex-auto"
          v-for="(question, index) in content[orderQuestion].question"
        >
          <CCol
            :class="
              index === 0
                ? 'firstLine firstLineQuestion-1'
                : 'secondLine secondLineQuestion-1'
            "
            ref="question"
            >{{ question.text }}</CCol
          >
        </CRow>
      </div>
      <div class="justify-content-end">
        <CRow class="choiceContainer text-center">
          <CCol
            md
            :class="'choice-' + (index + 1)"
            :key="index"
            @click="nextPage(choice.score)"
            class="choiceContent"
            v-for="(choice, index) in content[orderQuestion].choice"
          >
            <div class="choiceContent">{{ choice.text }}</div>
          </CCol>
        </CRow>
      </div>
    </div>

    <CButton
      v-if="bgSoundEnable"
      @click="onBGSoundPause"
      class="btn-control btn-sound"
      v-c-tooltip="'SOUND'"
    >
      <font-awesome-icon :icon="['fas', 'volume-up']" />
    </CButton>
    <CButton
      v-else
      @click="onBGSoundPlay"
      class="btn-control btn-sound"
      v-c-tooltip="'SOUND'"
    >
      <font-awesome-icon :icon="['fas', 'volume-mute']" />
    </CButton>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  name: 'Question',
  data() {
    return {
      // testAnimated: 'slide-left',
      orderQuestion: 0,
      content: [],
      score: 0,
      courseCode: '',
      courseSection: 0,
      startTime: '',
      prevAction: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      bgSoundEnable: true,
      questionNum: 0,
      templateId: '',
      paticipationId: '',
      interactionId: '',
      knowledgeId: '',
    };
  },
  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;
    console.log('this.courseCode', this.courseCode);

    this.startTime = this.$helpers.getDateFormat();
  },
  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = 'CPR-E2';
    // this.$store.dispatch('template/fetchContent', body);
    // console.log('this.courseCode', this.courseCode);

    const templateCode = 'CPR-E2';

    this.$store.dispatch('v3/fetchTemplateByCode', templateCode);
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      questions: 'template/getTemplateContent',
      getTemplateCriteria: 'template/getUserTemplate',
      loadingGetter: 'template/loadingGetter',
    }),
    animationStyle() {
      switch (this.orderQuestion) {
        case 1:
          return 'slide-up';
        case 2:
          return 'slide-left';
        case 3:
          return 'slide-diagnal';
        case 4:
          return 'slide-diagnal-zoom-out';
        case 5:
          return 'slide-left-scale-down';
        default:
          return 'default';
      }
    },
  },
  watch: {
    getTemplatev3(val) {
      console.log(val, 'gettemp');
      const template = val.templates[0];
      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      } else {
        this.templateId = val._id;
        let value = template.content.question;
        this.questionNum = template.content.question.length;
        for (let i = 0; i < value.length; i++) {
          let payload = {
            question: [],
            choice: [],
          };
          payload.index = i;
          for (let j = 0; j < value[i].item.length; j++) {
            if (value[i].item[j].data.includes('-')) {
              let temp = [];
              temp = value[i].item[j].data.split('-');
              for (let k = 0; k < temp.length; k++) {
                payload.question.push({text: temp[k]});
              }
            } else {
              payload.question.push({text: value[i].item[j].data});
            }
          }
          for (let j = 0; j < value[i].choices.length; j++) {
            payload.choice.push({
              text: value[i].choices[j].choice.choices.title[0].value,
              score: value[i].choices[j].choice.choices.score,
            });
          }
          this.content.push(payload);
        }
        console.log(this.content);

        // this.courseSection =
        //   this.$store.getters['necessary/getLerningCourse'].groups[0].code;
        // this.$store.dispatch('template/createUserTemplateData', {
        //   code: this.courseCode,
        //   template: val._id,
        //   section: this.courseSection,
        // });
        this.prevAction = template.navigate.previous.action;
      }
    },
    // questions: function (val) {
    //   if (!val.enable) {
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.templateId = val._id;
    //     let value = val.content.question;
    //     this.questionNum = val.content.question.length;
    //     for (let i = 0; i < value.length; i++) {
    //       let payload = {
    //         question: [],
    //         choice: [],
    //       };
    //       payload.index = i;
    //       for (let j = 0; j < value[i].item.length; j++) {
    //         if (value[i].item[j].data.includes('-')) {
    //           let temp = [];
    //           temp = value[i].item[j].data.split('-');
    //           for (let k = 0; k < temp.length; k++) {
    //             payload.question.push({text: temp[k]});
    //           }
    //         } else {
    //           payload.question.push({text: value[i].item[j].data});
    //         }
    //       }
    //       for (let j = 0; j < value[i].choices.length; j++) {
    //         payload.choice.push({
    //           text: value[i].choices[j].choice.choices.title[0].value,
    //           score: value[i].choices[j].choice.choices.score,
    //         });
    //       }
    //       this.content.push(payload);
    //     }
    //     this.courseSection =
    //       this.$store.getters['necessary/getLerningCourse'].groups[0].code;
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //     this.prevAction = val.navigate.previous.action;
    //   }
    // },
    // getTemplateCriteria: function (val) {
    //   val.data.condition.criteriaType.filter((item, index) => {
    //     if (
    //       this.$helpers.translate(item.criteria.name, 'en') == 'paticipation'
    //     ) {
    //       this.paticipationId = item.criteria._id;
    //     } else if (
    //       this.$helpers.translate(item.criteria.name, 'en') == 'interaction'
    //     ) {
    //       this.interactionId = item.criteria._id;
    //     } else if (
    //       this.$helpers.translate(item.criteria.name, 'en') == 'knowledge'
    //     ) {
    //       this.knowledgeId = item.criteria._id;
    //     }
    //   });
    // },
    loadingGetter: function (val) {},
  },
  methods: {
    onBGSoundPlay() {
      this.$refs.bgSound.play();
      this.bgSoundEnable = true;
    },
    onBGSoundPause() {
      this.$refs.bgSound.pause();
      this.bgSoundEnable = false;
    },
    mainPage() {
      this.$router.push('/v4/findyourway');
    },
    onClose() {
      this.$router.push({
        path: '/v4/CPR/preview/' + this.prevAction,
      });
    },
    disableClick(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    nextPage(score) {
      this.score += score;

      document.addEventListener('click', this.disableClick, true);
      if (this.orderQuestion === this.content.length - 1) {
        const knowledgeScore = (this.score / this.questionNum) * 70;
        // const userCriteria = {
        //   code: this.courseCode,
        //   template: this.templateId,
        //   section: this.courseSection,
        //   answering: [],
        //   startTime: this.startTime,
        //   endTime: this.$helpers.getDateFormat(),
        //   condition: [
        //     {
        //       criteria: this.paticipationId, // การวัดผลด้านต่างๆ
        //       val: 10,
        //     },
        //     {
        //       criteria: this.interactionId,
        //       val: 20,
        //     },
        //     {
        //       criteria: this.knowledgeId,
        //       val: knowledgeScore,
        //     },
        //   ],
        // };

        // this.$store.dispatch('template/saveUserTemplateData', userCriteria);
        this.$router.push({
          name: 'v4CPRSummary',
          params: {
            id: 'CPR-SUM02',
          },
        });
      }
      // when move to new question will increase index so class will increase too
      // different class has different animation
      this.orderQuestion++;

      if (this.content.length >= this.orderQuestion + 1) {
        // remove all class from firstLineQuestion-1-> 6
        for (let i = 0; i <= this.content.length; i++) {
          this.$refs.question[0].classList.remove('firstLineQuestion-' + i);
          if (this.orderQuestion < 4) {
            this.$refs.question[1].classList.remove('secondLineQuestion-' + i);
          }
        }

        // add class firstQuestion-1-> 6 for using different animation

        for (let i = 0; i <= this.$refs.question.length; i++) {
          this.$refs.question[0].classList.add(
            'firstLineQuestion-' + (this.orderQuestion + 1)
          );
          if (this.orderQuestion < 4) {
            this.$refs.question[1].classList.add(
              'secondLineQuestion-' + (this.orderQuestion + 1)
            );
          }
        }
      }
      setTimeout(() => {
        document.removeEventListener('click', this.disableClick, true);
      }, 1500);
    },
  },
};
</script>

<style scoped>
@import '../../../assets/scss/CPR/style.scss';

.btn-control {
  background: #d9d9d9 0% 0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  position: absolute;
  z-index: 99;
  color: #000;
  right: 5%;
  font-size: 20px;
  font-weight: 300;
}
.btn-sound {
  bottom: 3.65rem;
}
.btn-close {
  top: 15%;
}

.testBackground-1 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-1.png');
}

.testBackground-2 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-2.png');
  transition: 1000ms linear;
}

.testBackground-3 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-3.png');
  transition: 1000ms linear;
}

.testBackground-4 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-4.png');
  transition: 1000ms linear;
}

.testBackground-5 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-5.png');
  transition: 1000ms linear;
}

.testBackground-6 {
  background-image: url('../../../assets/images/CPR/E2/question-bg-6.png');
  transition: 1000ms linear;
}

.backgroundCircle1 {
  width: 840px;
  height: 840px;
  right: 0;
  border: 2px solid white;
  opacity: 0.3;
  border-radius: 50%;
  position: absolute;
}
.backgroundCircle2 {
  margin: 4rem;
  width: 700px;
  height: 700px;
  right: 0;
  border: 2px solid white;
  opacity: 0.3;
  border-radius: 50%;
  position: absolute;
}
.backgroundCircle3 {
  margin: 9rem;
  width: 540px;
  height: 540px;
  right: 0;
  border: 2px solid white;
  opacity: 0.3;
  border-radius: 50%;
  position: absolute;
}
.backgroundCircle4 {
  margin: 13rem;
  width: 420px;
  height: 420px;
  right: 0;
  border: 2px solid white;
  opacity: 0.3;
  border-radius: 50%;
  position: absolute;
}
.big-circle {
  position: relative;
  top: -9rem;
}

.big-circle-slide-up > * {
  animation: slide-up 1.5s forwards;
}

.big-circle-slide-left > * {
  animation: slide-left 1.5s forwards ease-in-out;
}

.big-circle-slide-diagnal > * {
  overflow-y: hidden;

  animation: slide-diagnal 1.5s forwards ease-in-out;
  left: 0 !important;
}

.big-circle-slide-diagnal-zoom-out > * {
  animation: slide-diagnal-zoom-out 1.5s forwards ease-in-out;
}

.big-circle-slide-left-scale-down > * {
  animation: slide-left-scale-down 1.5s forwards ease-in;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.mainBackground {
  overflow-y: hidden;
  overflow-x: hidden;
  min-height: 100vh;
  background-size: cover;
}
.cancelMark {
  padding-top: 3rem;
  margin-bottom: 4.5rem;
  padding-right: 7rem;
}
.soundMark {
  position: absolute;
  bottom: 4rem;
  width: 100%;
  padding-right: 7rem;
}
.firstLineQuestion-1 {
  padding-top: 15%;
  padding-right: 10%;
  font-size: 3rem;
  animation: text-slide-right 0.5s forwards;
  color: white;
}

.secondLineQuestion-1 {
  padding-right: 10%;
  font-size: 5rem;
  animation: text-slide-right 0.5s forwards;
  color: white;
}

.firstLineQuestion-2 {
  text-align: center;

  padding-top: 15%;
  color: white;
  left: 0px;
  font-size: 4rem;
  animation: fade-in 0.5s forwards;
}

.secondLineQuestion-2 {
  text-align: center;
  margin-top: 0;
  margin-left: 10%;
  font-size: 5rem;
  animation: fade-in-delay 0.5s forwards;
  animation-delay: 1.5s;
  visibility: hidden;
  color: white;
}

.firstLineQuestion-3 {
  text-align: center;
  width: 100%;
  padding-top: 20%;
  font-size: 2.5rem;
  color: white;
  -webkit-animation: fade-in-data-v-98ca361e 0.5s forwards;
  animation: fade-in-data-v-98ca361e 0.5s forwards;
}

.secondLineQuestion-3 {
  text-align: center;
  color: white;
  font-size: 4rem;
  animation: fade-in-delay 0.5s forwards;
  animation-delay: 1.5s;
  visibility: hidden;
  margin-left: 10%;
}

.firstLineQuestion-4 {
  all: unset;
  width: 40%;
  margin: auto;
  text-align: left;
  padding-top: 20%;
  color: white;
  font-size: 5rem;
  animation: fade-in 0.5s forwards;
}

.secondLineQuestion-4 {
  all: unset;
  width: 40%;
  margin: auto;
  text-align: left;
  font-size: 5rem;
  animation: fade-in-delay 0.5s forwards;
  animation-delay: 1.5s;
  visibility: hidden;
  color: white;
}

.firstLineQuestion-5 {
  padding-top: 20%;
  color: white;
  width: 60%;
  text-align: center;
  font-size: 5rem;
  -webkit-animation: fade-in-data-v-98ca361e 0.5s forwards;
  animation: fade-in-data-v-98ca361e 0.5s forwards;
}

.secondLineQuestion-5 {
  padding-right: 16rem;
  color: white;
  font-size: 4rem;
  animation: text-slide-right 0.5s forwards;
}

.firstLineQuestion-6 {
  padding-top: 20%;
  color: white;
  width: 60%;
  text-align: center;
  font-size: 5rem;
  -webkit-animation: fade-in-data-v-98ca361e 0.5s forwards;
  animation: fade-in-data-v-98ca361e 0.5s forwards;
}

.secondLineQuestion-6 {
  padding-right: 16rem;
  font-size: 4rem;
  color: white;
  animation: fade-in 0.5s forwards;
}
@media screen and (max-width: 1440px) {
  .firstLineQuestion-4 {
    font-size: 3rem;
  }
  .secondLineQuestion-4 {
    font-size: 3rem;
  }
  .firstLineQuestion-5 {
    font-size: 3rem;
  }
  .secondLineQuestion-5 {
    font-size: 3rem;
  }
  .firstLineQuestion-6 {
    font-size: 4rem;
  }
  .secondLineQuestion-6 {
    font-size: 3rem;
  }
}
.choice-1 {
  cursor: pointer;
  backdrop-filter: blur(1800px);
  -webkit-backdrop-filter: blur(1800px);
  font-size: 1.4rem;
  border-top-left-radius: 5rem;
  border-bottom-left-radius: 5rem;
  transition: all 0.3s ease-in-out;
  background-color: rgba(200, 200, 200, 0.4);
  z-index: 2;
  text-align: center;
}

.choice-2 {
  cursor: pointer;
  backdrop-filter: blur(120px);
  -webkit-backdrop-filter: blur(120px);
  color: white;
  font-size: 1.4rem;
  border-color: black;
  transition: all 0.5s;
  background-color: rgba(200, 200, 200, 0.4);
  z-index: 2;
  text-align: center;
}

.choice-3 {
  cursor: pointer;
  backdrop-filter: blur(120px);
  -webkit-backdrop-filter: blur(120px);
  color: white;
  font-size: 1.4rem;
  border-color: black;
  border-top-right-radius: 5rem;
  border-bottom-right-radius: 5rem;
  transition: all 0.5s;
  background-color: rgba(200, 200, 200, 0.4);
  z-index: 2;
  text-align: center;
}

.choice-1:hover,
.choice-2:hover,
.choice-3:hover {
  cursor: pointer;
  transform: scale(1.1, 1.1);
  z-index: 99;
  background: rgba(225, 255, 255, 0.99) !important;
}

.choiceContainer {
  animation: fade-in-delay 1s forwards;
  animation-delay: 0.5s;
  visibility: hidden;
  opacity: 0;
  /*
  position: absolute;
  bottom: 0;
  */
  margin-bottom: auto;
  width: 100%;

  padding-left: 11rem;
  padding-right: 11rem;
  padding-bottom: 2rem;
}

.choiceContent {
  white-space: normal;
  overflow-wrap: break-word;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 130px;
  margin-top: 2rem;
  margin-bottom: 2rem;
  margin-right: 0.2rem;
  padding: 1.2rem;
  color: #000;
  font-weight: 400;
}
@media screen and (max-width: 768px) {
  .firstLineQuestion-1,
  .secondLineQuestion-1,
  .firstLineQuestion-2,
  .secondLineQuestion-2,
  .firstLineQuestion-3,
  .secondLineQuestion-3,
  .firstLineQuestion-4,
  .secondLineQuestion-4,
  .firstLineQuestion-5,
  .secondLineQuestion-5,
  .firstLineQuestion-6,
  .secondLineQuestion-6 {
    width: 100%;
  }
  .choiceContainer {
    width: 90%;
    height: auto;
    margin: 5%;
    padding: 0 !important;
  }
  .choiceContent {
    border-radius: 0 !important;
    height: auto;
    display: block;
    margin: 3px;
  }
}
.slide-fade-enter-active {
  transition: all 1s ease;
}
/* .slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
} */
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-20rem);
}

@keyframes text-slide-right {
  from {
    transform: translateX(-50rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes fade-in-delay {
  from {
    visibility: visible;
    opacity: 0;
  }
  to {
    visibility: visible;
    opacity: 1;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slide-up {
  from {
    top: 0rem;
  }
  to {
    top: -15rem;
  }
}

@keyframes slide-left {
  from {
    top: -15rem;
    right: 0rem;
  }
  to {
    top: -15rem;
    right: 50rem;
  }
}

@keyframes slide-diagnal {
  from {
    transform: translate(-3rem, -3rem);
  }
  to {
    transform: translate(12rem, 12rem);
  }
}

@keyframes slide-diagnal-zoom-out {
  from {
    transform: translate(0, 0) scale(1);
  }
  to {
    transform: translate(5rem, -5rem) scale(0.5);
  }
}

@keyframes slide-left-scale-down {
  from {
    transform: scale(0.5);
    top: -4.85rem;
    right: -2rem;
  }
  to {
    transform: scale(0.5);
    top: -4.85rem;
    right: 40rem;
  }
}
</style>
